import { useContext } from 'react';
import { useQuery } from '@apollo/client';
import { GET_UNSEEN_NOTIFICATIONS } from '../data/queries';
import { UnseenNotificationDto } from '../helpers/dtos';
import { AuthContext } from '../context';

export const useUnseenReports = () => {
  const { loggedUser } = useContext(AuthContext);
  const { data, loading, error, refetch } = useQuery<UnseenNotificationDto>(
    GET_UNSEEN_NOTIFICATIONS,
    {
      pollInterval: 60000,
      fetchPolicy: 'network-only',
      skip: !loggedUser?.id,
      variables: { skipAlerts: false },
    }
  );

  const unseenReportsTotal = data?.unseenReports?.totalItems ?? 0;
  const unseenAlertsTotal = data?.unseenAlerts?.totalItems ?? 0;

  return {
    totalUnseenNotifications: unseenReportsTotal + unseenAlertsTotal,
    unseenReportsTotal,
    unseenAlertsTotal,
    loading,
    error,
    refetch,
  };
};
